import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LangChange} from '../../../../../../lang-change';
import {Utils} from '../../../../../../common/services/Utils';
import {EnrollCabinet} from '../../../model/enroll-cabinet';
import {TranslateService} from '@ngx-translate/core';
import {MatDialog} from '@angular/material';
import {Language} from '../../../../../../common/models/language';
import {FileServiceModerator} from '../../../../../moderator/services/file-service-moderator.service';
import {FileService} from '../../../../../shared/services/file.service';
import {DictionaryService} from '../../../../../shared/services/dictionary.service';
import {CenterCollegeService} from '../../../../../../common_services/center-college.service';
import {AdmissionSubjectTypeEnum} from '../../../../../shared/components/dictionary/subject-for-admission-list/admission-subject-type.enum';
import {ApplicantStatusEnum} from '../../../../../../common/enums/applicant-status.enum';
import {AttestatBallCalaulateDialogComponent} from 'app/modules/enroll/components/enroll-cabinet/tabs/enroll-edu-info/attestat-ball-calaulate-dialog/attestat-ball-calaulate-dialog.component';
import {AdmissionService} from "../../../../../shared/services/admission.service";
import {ExamsSubjectsBalls} from '../../../model/edu-info/exams-subjects-balls';

@Component({
  selector: 'app-enroll-edu-info',
  templateUrl: './enroll-edu-info.component.html',
  styleUrls: ['./enroll-edu-info.component.scss']
})
export class EnrollEduInfoComponent extends LangChange implements OnInit {

  maxFileSize = 5012000;
  /* subjects and balls for exam */
  mandatorySubjs: any[];
  selectedMandatorySubjs: any[] = [];
  selectedMandatoryBalls: any[] = [];
  profileSubjs: any[];
  selectedProfileSubjs: any[] = [];
  selectedProfileBalls: any[] = [];
  /* subjects and balls for exam on 11-12 ENT */
  mandatoryEntSubjs: any[];
  selectedMandatoryEntSubjs: any[] = [];
  selectedMandatoryEntBalls: any[] = [];
  profileEntSubjs: any[];
  selectedProfileEntSubjs: any[] = [];
  selectedProfileEntBalls: any[] = [];

  subjectsBallsCount: any = null;
  educated: any[] = [];
  domesticUnivData: any = {
    edu_graduate_domestic_univ_name: null,
    edu_graduate_domestic_univ_spec: null
  };

  subjectMap = {};

  constructor(public _translateService: TranslateService,
              private fileService: FileService,
              private fileModeratorService: FileServiceModerator,
              private _dictionaryService: DictionaryService,
              private _centerCollegeService: CenterCollegeService,
              private dialog: MatDialog,
              private utils: Utils) {
    super(_translateService);
  }

  @Input() public data: EnrollCabinet;
  @Input() public dics: any;
  @Input() public eduInstituteOrgName: any;
  @Input() public applicationFormDisabled: boolean;
  @Input() public isTechSecretary: boolean;
  @Input() public applicationStatus: any;
  @Output() changeCabinetFunction: EventEmitter<any> = new EventEmitter();

  eduOrgNames: any[] = null; // список уч заведении, заполняется после ввода места окончания уч.заведения

  onLangChange(language: Language): void {
  }

  ngOnInit() {
    // this.utils.blockStart();
    this.getInstitution().then(value => { // заполняем список уч заведении
    }, reason => {
      console.log('EnrollEduInfoComponent getInstitution() error:', reason);
    });
  }


  eduInstituteGraduateChanged() {
    if (this.data.edu_info.edu_institute_graduate === 2) {
      this.data.edu_info.edu_received = 3;
      this.data.edu_info.type_of_admission = 0;
    }
    if (this.data.edu_info.edu_institute_graduate === 1) {
      this.data.edu_info.edu_received = 1;
    }
    this.changeCabinetFunction.emit({functionName: 'loadEducatedList'});
    this.data.entrance_info.speciality = 0;
    this.data.entrance_info.qualification = 0;
    this.data.edu_info.institutionId = null;
    this.data.collegeId = 0;
    this.getInstitution();
    this.changeCabinetFunction.emit({functionName: 'loadCenterProfession'});
    this.changeCabinetFunction.emit({functionName: 'resetAlternativeColleges'});
    this.data.edu_info.attestat.attestat_average_ball = '';
  }

  educatedChanged() {
    this.data.entrance_info.speciality = 0;
    this.data.entrance_info.qualification = 0;
    this.changeCabinetFunction.emit({functionName: 'loadCenterProfession'});
    this.changeCabinetFunction.emit({functionName: 'resetAlternativeColleges'});
  }

  public getInstitution() {
    return new Promise((resolve, reject) => {
      if (this.data.edu_info.edu_institute_localty && this.data.edu_info.edu_institute_localty.id) {
        if (this.data.edu_info.edu_institute_graduate === 1) {
          this.getInstitutionByRegionCode().then(value => {
            resolve(this.eduOrgNames);
          }, reason => {
            console.log('getInstitution getInstitutionByRegionCode err:', reason);
            reject();
          });
        } else if (this.data.edu_info.edu_institute_graduate === 2) {
          this.getCollegeListByCato().then(value => {
            resolve(this.eduOrgNames);
          }, reason => {
            console.log('getInstitution getCollegeListByCato err:', reason);
            reject();
          });
        }
      } else {
        this.eduOrgNames = [];
        this.data.edu_info.institutionId = null;
      }
    });
  }

  getInstitutionByRegionCode() {
    return new Promise((resolve, reject) => {
      this._dictionaryService.getInstitutionByRegionCode(this.data.edu_info.edu_institute_localty.id).subscribe(res => {
        if (res) {
          this.eduOrgNames = res;
        }
        resolve('done');
      }, err => {
        this.utils.notifyError(this._translateService.instant('error_occurred'), '');
        reject(err);
      });
    });
  }

  getCollegeListByCato() {
    return new Promise((resolve, reject) => {
      this._centerCollegeService.getCollegeListByCato(this.data.edu_info.edu_institute_localty.id).subscribe(res => {
        if (res) {
          this.eduOrgNames = res;
        }
        resolve('done');
      }, err => {
        this.utils.notifyError(this._translateService.instant('error_occurred'), '');
        reject(err);
      });
    });
  }

  fileInputChangeEvent(fileInput: any, item: number) {
    if (fileInput.target.files && fileInput.target.files[0]) {
      if (fileInput.target.files[0].size > this.maxFileSize) {
        this.utils.notifyError(this._translateService.instant('enroll_cabinet_page.upload_file_size_exceed'), '');
        return false;
      } else {
        const file: File = fileInput.target.files[0];
        const formData = new FormData();
        formData.append('file', file, file.name);
        this.fileModeratorService.uploadFile(formData).subscribe(res => {
          this.changeDataFile(item, res);
        });
      }
    }
  }

  changeDataFile(item: number, data: any) {
    switch (item) {
      case 0:
        this.data.edu_info.edu_doc_scan = data;
        break;
      case 1:
        this.data.edu_info.attestat.attestat_app_scan = data;
        break;
      case 2:
        this.data.edu_info.ent_kt_serificate_info.ent_kt_serificate_scan = data;
        break;
      case 3:
        this.data.edu_info.interview_info.interview_result_mark = data;
        break;
      case 4:
        this.data.edu_info.diplom_info.diplom_scan = data;
        break;
      case 5:
        this.data.edu_info.diplom_info.essay = data;
        break;
      case 6:
        this.data.edu_info.attestat.attestat_scan = data;
        break;
      case 7:
        this.data.edu_info.diplom_info.diplom_app_scan = data;
        break;
    }
  }

  deleteFile(fileId: any, item: number) {
    this.utils.confirmDialog({message: 'delete_confirmation'}, () => {
      this.fileModeratorService.deleteFile(fileId).subscribe(res => {
        this.changeDataFile(item, null);
      });
    });
  }
  getFile(id: any) {
    this.utils.blockStart(null);
    this.fileService.getFileInfo(id).subscribe((fileInfo) => {
      this.fileService.getFile(fileInfo.fileId).subscribe((data) => {
        this.fileService.downloadPsFile(data, fileInfo);
        this.utils.blockStop();
      });
    });
  }

  univerOperationStateRadioChecked(event) {
    if (this.data.edu_info.edu_graduate_domestic_operating_univ === 2) {
      this.domesticUnivData.edu_graduate_domestic_univ_name = this.data.edu_info.edu_graduate_domestic_univ_name;
      this.domesticUnivData.edu_graduate_domestic_univ_spec = this.data.edu_info.edu_graduate_domestic_univ_spec;
      this.data.edu_info.edu_graduate_domestic_univ_name = '';
      this.data.edu_info.edu_graduate_domestic_univ_spec = '';
    } else if (this.data.edu_info.edu_graduate_domestic_operating_univ === 1) {
      this.data.edu_info.edu_graduate_domestic_univ_name = this.domesticUnivData.edu_graduate_domestic_univ_name;
      this.data.edu_info.edu_graduate_domestic_univ_spec = this.domesticUnivData.edu_graduate_domestic_univ_spec;
    }
  }

  notSavedAndNotSubmitted() {
    if (this.applicationStatus) return (this.applicationStatus !== ApplicantStatusEnum.SAVED_NOT_SUBMITTED || this.applicationStatus !== ApplicantStatusEnum.SUBMITTED);
    return false;
  }

  calculateAttestsAverageBall() {
    this.dialog.closeAll();
    this.data.edu_info.attestat.averageBallCalculation.enrollId = this.data.enrollId;
    const dialogRef = this.dialog.open(AttestatBallCalaulateDialogComponent, {
      width: '330px',
      height: '300px',
      disableClose: true,
      data: this.data.edu_info.attestat.averageBallCalculation
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.data.edu_info.attestat.attestat_average_ball = result.average;
        this.data.edu_info.attestat.averageBallCalculation = result;
      }
    });
  }

  changeQuota(){
    if (this.data.edu_info.edu_institute_place == 2 && this.data.entrance_info.payment_form == 2 &&
       (this.data.quota.quotaid == 0 || this.data.quota.quotaid == undefined)){
      this.data.quota.quotaid = 3;
    } else if((this.data.edu_info.edu_institute_place == 1 || this.data.entrance_info.payment_form == 1)
               && this.data.quota.quotaid == 3){
      this.data.quota.quotaid = 0;
    }
  }

  instituteCountryChanged() {
    this.data.entrance_info.speciality = 0;
    this.data.entrance_info.qualification = 0;
    this.data.edu_info.institutionId = null;
    this.data.collegeId = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/enroll-cabinet/tabs/enroll-edu-info/enroll-edu-info.component.ts